/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './howLoanProgramWorks.css';
import parse from 'html-react-parser';

function HowLoanProgramWorks({ data }) {
  // If no data is provided, don't render the component
  if (!data) return null;
  
  const { 
    title, 
    steps, 
    explain, 
    columnSize = 4,
    titleColor = "#FF3F00",       // Default color if not provided in JSON
    zigzagColor = "#FF3F00",      // Default color for zigzag underline
    headerBackgroundColor = "#FF3F00"  // Default color for step headers
  } = data;

  // below function is added so tat if any of page does not have that particular parameter called like (title, explain, description etc) then it will not shoe error to that page
  const safeParse = (content) => {
    if (content === undefined || content === null) return '';
    return parse(content.toString());
  };

  return (
    <div className="how-loan-works-section">
      <Container>
        <Row className="justify-content-center">
          <Col lg={12} className="text-center">
            <h2 
              className="how-loan-works-title" 
              style={{
                color: titleColor,
                textDecorationColor: zigzagColor
              }}
            >
              {safeParse(title)}
            </h2>
            <p className="how-loan-works-explain">{safeParse(explain)}</p>
          </Col>
        </Row>
        <Row className="justify-content-center how-loan-works-step-row g-4">
          {steps && steps.map((step, index) => (
            <Col lg={12 / columnSize} key={index} className="how-loan-works-step-container">
              <div className="how-loan-works-step">
                <div className="how-loan-works-step-inner">
                  <div 
                    className="how-loan-works-step-header" 
                    style={{ backgroundColor: headerBackgroundColor }}
                  >
                    <h3 className="how-loan-works-step-title">{safeParse(step.title)}</h3>
                  </div>
                  <div className="how-loan-works-step-content">
                    <p>{safeParse(step.description)}</p>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default HowLoanProgramWorks;